import { useStore } from 'zustand';
import { useShallow } from 'zustand/shallow';

import { inventoryStore } from '../InventoryStore';

/**
 * Optimized selector hook for ExtranetInventory component
 * Uses shallow comparison to prevent unnecessary re-renders
 *
 * @returns Selected inventory state with minimal re-render triggers
 */
export const useInventoryState = () => {
  return useStore(
    inventoryStore,
    useShallow((state) => ({
      tab: state.tab,
      packType: state.packType,
      timePeriod: state.timePeriod,
      endOfSaleDate: state.endOfSaleDate,
    }))
  );
};

/**
 * Optimized selector hook for inventory actions
 * Separates actions from state to prevent re-renders when state changes
 *
 * @returns Inventory store actions
 */
export const useInventoryActions = () => {
  return useStore(
    inventoryStore,
    useShallow((state) => ({
      setInventory: state.setInventory,
      setDependencies: state.setDependencies,
      setRawInventory: state.setRawInventory,
    }))
  );
};
